import { connect } from 'react-redux';
import { openDrawer } from 'redux-core/dialogs/actions';

const mapDispatchToProps = {
  openDrawer,
};

export default connect(null, mapDispatchToProps);
